import { ServiceAgreementDetailResponse } from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { ServiceAgreementInfo } from './information/service-agreement-info';

export const useGetServiceAgreementDetailsTab = (data: ServiceAgreementDetailResponse) => {
  const { t } = useTranslation('ogp-screen-specific');
  return [
    {
      id: 'service-agreement-information',
      tabLabel: t('collegial_lending_page.service-agreement.information'),
      element: <ServiceAgreementInfo data={data} />,
    },
  ];
};
